import React from 'react';

const RouteLoadingFallback = () => (
  <div className="d-flex justify-content-center align-items-center p-5">
    <div
      className="spinner-border"
      role="status"
      style={{ color: '#f6c026' }}
    >
      <span className="sr-only">Loading...</span>
    </div>
  </div>
);

export default RouteLoadingFallback;
